<template>
  <div class="customPermission">
    <div class="container">
      <div class="page-heading">
        <h2>Custom Permission List</h2>
        <button
          type="button"
          class="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#addCustomPermissionModalOpen"
          @click="emptyFormValues"
        >
          <i class="bi bi-file-plus"></i> Add Custom Permission
        </button>
      </div>
      <div class="page-content mt-3">
        <div class="row">
          <div class="col-md-12">
            <div v-if="isLoading" class="container">
              <div class="d-flex justify-content-center mt-5">
                <loader></loader>
              </div>
            </div>
            <div v-else>
              <div class="card">
                <div class="card-body">
                  <template v-if="customPermissionLists.length > 0">
                    <CustomDataTable
                      :searchParams="[
                        'display_name',
                        'route_name',
                        'parent_route.display_name',
                        'parent_route.route_name',
                        'route_type'
                      ]"
                      :filteredData="customPermissionLists"
                      @fetchPaginatedData="fetchPaginatedData"
                    >
                      <table class="table table-hover table-bordered">
                        <thead class="table-light">
                          <tr>
                            <th>ID</th>
                            <th>Display Name</th>
                            <th>Route Name</th>
                            <th>Parent Name</th>
                            <th>Route Type</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <template
                            v-for="(
                              customPermissionList, index
                            ) in paginatedCustomPermissionList"
                            :key="customPermissionList.id"
                          >
                            <tr>
                              <td>
                                {{ index + 1 }}
                              </td>
                              <td>{{ customPermissionList.display_name }}</td>
                              <td>{{ customPermissionList.route_name }}</td>
                              <td>
                                <span v-if="customPermissionList.parent_route">
                                  {{
                                    customPermissionList.parent_route
                                      .display_name
                                      ? customPermissionList.parent_route
                                          .display_name
                                      : customPermissionList.parent_route
                                          .route_name
                                  }}
                                </span>
                              </td>
                              <td>{{ customPermissionList.route_type }}</td>
                              <td>
                                <button
                                  class="btn btn-xs btn-primary"
                                  style="margin-right: 5px"
                                  data-bs-toggle="modal"
                                  @click="
                                    getIdWiseCustomPartnerList(
                                      customPermissionList.id
                                    )
                                  "
                                  data-bs-target="#editCustomPermissionModalOpen"
                                >
                                  <i class="bi bi-pencil-square"></i>
                                </button>
                                <button
                                  class="btn btn-xs btn-danger"
                                  @click="
                                    deleteIdWiseCustomPermission(
                                      customPermissionList.id
                                    )
                                  "
                                >
                                  <i class="bi bi-trash-fill"></i>
                                </button>
                              </td>
                            </tr>
                          </template>
                        </tbody>
                        <tfoot></tfoot>
                      </table>
                    </CustomDataTable>
                    <!-- <div class="container pb-8">
                      <Pagination
                        :totalPages="totalPages"
                        :total="total"
                        :currentPage="currentPage"
                        :perPage="perPage"
                        v-on:pagechanged="getAllCustomPermissionList"
                      ></Pagination>
                    </div> -->
                  </template>
                  <template v-else>
                    <p
                      class="mt-3 alert alert-danger"
                      style="text-align: center"
                    >
                      No Data Found 😢
                    </p>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <teleport to="body">
    <div
      class="modal fade"
      id="editCustomPermissionModalOpen"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <form @submit.prevent="updateCustomPermission">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="staticBackdropLabel">
                Edit Custom permission
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="container">
                <div class="row">
                  <div class="col-md-6">
                    <label for="" class="form-label">Display Name</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="formValue.display_name"
                      placeholder="Display Name"
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="" class="form-label">Name</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="formValue.route_name"
                      placeholder="Custom Access Name"
                      required
                    />
                  </div>
                </div>
                <div class="row" style="margin-top: 10px">
                  <div class="col-md-6">
                    <label for="" class="form-label">Parent Name</label>
                    <multiselect
                      v-model="formValue.parent_route_id"
                      :closeOnSelect="true"
                      :searchable="true"
                      :resetAfter="true"
                      :options="parentRouteList"
                      placeholder="Parent Name"
                      label="name"
                      track-by="name"
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="" class="form-label">Type</label>
                    <select class="form-select" v-model="formValue.route_type">
                      <option value="frontend">Frontend</option>
                      <option value="backend">Backend</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                ref="updateModalCloseBtn"
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="submit" class="btn btn-primary">Update</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </teleport>

  <teleport to="body">
    <div
      class="modal fade"
      id="addCustomPermissionModalOpen"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <form @submit.prevent="storeCustomPermission">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="staticBackdropLabel">
                Add Custom permission
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="container">
                <div class="row">
                  <div class="col-md-6">
                    <label for="" class="form-label">Display Name</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="formValue.display_name"
                      placeholder="Display Name"
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="" class="form-label">Name</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="formValue.route_name"
                      placeholder="Custom Access Name"
                      required
                    />
                  </div>
                </div>
                <div class="row" style="margin-top: 10px">
                  <div class="col-md-6">
                    <label for="" class="form-label">Parent Name</label>
                    <multiselect
                      v-model="formValue.parent_route_id"
                      :closeOnSelect="true"
                      :searchable="true"
                      :resetAfter="true"
                      :options="parentRouteList"
                      placeholder="Parent Name"
                      label="name"
                      track-by="name"
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="" class="form-label">Type</label>
                    <select class="form-select" v-model="formValue.route_type">
                      <option value="frontend">Frontend</option>
                      <option value="backend">Backend</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                ref="createModalCloseBtn"
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="submit" class="btn btn-primary">Store</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </teleport>
</template>

<script>
import http from '../config/axios';
// import Pagination from '../components/pagination/Pagination';
import Loader from '../components/lib/Loader';
import Multiselect from '@vueform/multiselect';
import CustomDataTable from '@/components/customDataTable/CustomDataTable.vue';

export default {
  name: 'CustomPermissionList',
  props: ['alert', 'swal'],
  components: {
    // Pagination,
    Loader,
    Multiselect,
    CustomDataTable
  },
  data() {
    return {
      customPermissionLists: [],
      customPermissionListHolder: [],
      parentRouteList: [],
      // totalPages: 0,
      // total: 0,
      // currentPage: 1,
      // perPage: 0,
      // pageCount: '',
      // to: 0,
      // from: 0,
      formValue: {
        route_name: '',
        display_name: '',
        parent_route_id: '',
        type: 'frontend'
      },
      getPermissionById: '',
      getPermissionName: '',
      permissionName: '',
      permission: '',
      isLoading: true
    };
  },
  mounted() {
    this.getAllCustomPermissionList();
  },
  methods: {
    mapParentRoutes() {
      this.parentRouteList = [];
      this.customPermissionLists.forEach((element) => {
        if (element.display_name) {
          this.parentRouteList.push({
            name: element.display_name,
            value: element.id
          });
        } else {
          this.parentRouteList.push({
            name: element.route_name,
            value: element.id
          });
        }
      });
    },
    fetchPaginatedData(paginatedData) {
      this.paginatedCustomPermissionList = paginatedData;
    },
    getAllCustomPermissionList() {
      this.isLoading = true;
      http
        .get(`/v2/role-permission/all-frontend-routes`)
        .then((response) => {
          if (response.status === 200) {
            this.customPermissionLists = response.data.data;
            this.customPermissionListHolder = response.data.data;
            this.mapParentRoutes();
            // this.total = response.data.data.total;
            // this.totalPages = response.data.data.last_page;
            // this.currentPage = response.data.data.current_page;
            // this.perPage = response.data.data.per_page;
            // this.to = response.data.data.to;
            // this.from = response.data.data.from;
            this.isLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getIdWiseCustomPartnerList(id) {
      var value = this.customPermissionListHolder.find(
        (data) => data.id === id
      );
      this.getPermissionById = value.id;
      this.getPermissionName = value.route_name;
      this.formValue = {
        route_name: value.route_name,
        display_name: value.display_name,
        parent_route_id: value.parent_route_id,
        route_type: value.route_type
      };
    },
    updateCustomPermission() {
      // let data = {
      //   route_name: this.getPermissionName
      // };
      http
        .patch(
          `/v2/role-permission/frontend-routes/${this.getPermissionById}`,
          this.formValue
        )
        .then((response) => {
          if (response.status === 200) {
            this.$swal({
              title: 'Success!',
              text: 'Your custom permission has updated.',
              icon: 'success',
              type: 'success',
              showConfirmButton: false,
              timer: 500
            });

            this.getAllCustomPermissionList();
            this.getPermissionById = '';
            this.getPermissionName = '';

            this.$refs.updateModalCloseBtn.click();
          }
        })
        .catch((error) => {
          console.log(error);
          if (
            error.response &&
            error.response.data &&
            error.response.data.route_name &&
            error.response.data.route_name.length > 0
          ) {
            this.$swal('Error!', error.response.data.route_name[0], 'error');
          }
        });
    },
    deleteIdWiseCustomPermission(id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You are about to delete this permisssion!',
        icon: 'warning',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#652f8f',
        cancelButtonColor: '#e2e555',
        confirmButtonText: 'Yes, delete!'
      }).then((result) => {
        if (result.value) {
          http
            .delete(`/v2/role-permission/frontend-routes/${id}`)
            .then((response) => {
              if (response.status === 200) {
                this.$swal({
                  title: 'Success!',
                  text: 'Your custom permission has deleted.',
                  icon: 'success',
                  type: 'success',
                  showConfirmButton: false,
                  timer: 500
                });

                this.getAllCustomPermissionList();
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    storeCustomPermission() {
      http
        .post(`/v2/role-permission/frontend-routes`, this.formValue)
        .then((response) => {
          if (response.status === 200) {
            this.$swal({
              title: 'Success!',
              text: 'Your custom permission has inserted.',
              icon: 'success',
              type: 'success',
              showConfirmButton: false,
              timer: 500
            });

            this.getAllCustomPermissionList();
            this.formValue = {
              route_name: '',
              display_name: '',
              parent_route_id: '',
              route_type: 'frontend'
            };

            this.$refs.createModalCloseBtn.click();
          }
        })
        .catch((error) => {
          console.log(error);
          if (
            error.response &&
            error.response.data &&
            error.response.data.route_name &&
            error.response.data.route_name.length > 0
          ) {
            this.$swal('Error!', error.response.data.route_name[0], 'error');
          }
        });
    },
    emptyFormValues() {
      this.formValue = {
        route_name: '',
        display_name: '',
        parent_route_id: '',
        route_type: 'frontend'
      };
    }
  }
};
</script>

<style scoped>
.table {
  font-size: 13px;
  font-style: normal;
}
.table thead > tr > th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  background: #f3f3f3;
}
.btn-xs {
  padding: 0.15rem 0.3rem !important;
  font-size: 0.75rem !important;
}
</style>
